import { render, staticRenderFns } from "./NewFQCSeleItem.vue?vue&type=template&id=391f42ca&scoped=true"
import script from "./NewFQCSeleItem.vue?vue&type=script&lang=js"
export * from "./NewFQCSeleItem.vue?vue&type=script&lang=js"
import style0 from "./NewFQCSeleItem.vue?vue&type=style&index=0&id=391f42ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f42ca",
  null
  
)

export default component.exports